<form [formGroup]="form">
	<lvr-section-form>
		<!-- Remark Field (Beschreibung) -->
		@let remarkCtrl = form.get('remark');
		<lvr-field lvrPadding [padHorizontal]="16" [padVertical]="0" [label]="'base.field.remark' | transloco">
			<mat-form-field lvrInput [lvrError]="hasError(remarkCtrl, 'maxLength')">
				<textarea
					matInput
					formControlName="remark"
					placeholder="Weiter Informationen"
					[maxlength]="env.formConfiguration.career.remarkLength"
					[errorStateMatcher]="matcher"
				></textarea>
				@if (hasError(remarkCtrl, 'maxLength')) {
					<mat-error>{{
						'client.career.error.maxLength' | transloco: { max: env.formConfiguration.career.remarkLength }
					}}</mat-error>
				}
				<mat-hint>{{
					'client.career.socialSecurityStatusRemarkHint'
						| transloco: { actual: remarkCtrl?.value?.length || 0, max: env.formConfiguration.career.remarkLength }
				}}</mat-hint>
			</mat-form-field>
		</lvr-field>
	</lvr-section-form>
</form>
